var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xbb"},[(_vm.dialog.visible)?_c('div',{staticClass:"flex items-center fullscreen xbb_dialog"},[_c('bonus-dialog-ad',{attrs:{"adPic":_vm.bonusData.Ad && _vm.bonusData.Ad.AdPic,"adUrl":_vm.bonusData.Ad && _vm.bonusData.Ad.AdUrl},on:{"close-dialog":_vm.closeDialog}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77917194","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/xbb/OnlyAd.vue
// module id = null
// module chunks = 